<template>
	<div class="maincontent">
		<div @click="hideSidebars" class="cover" :class="{'cover--show': showCover}"></div>
		<router-view />
		<PrevNextNavigation />
	</div>
</template>

<script>
import PrevNextNavigation from './PrevNextNavigation';
import FireLogicOnInitMixin from '../mixins/fire-logic-on-init';

export default {
	name: 'MainContent',
	mixins: [FireLogicOnInitMixin],
	components: {PrevNextNavigation},
	computed: {
		showCover() {
			return (
				(this.$store.state.app.media === 'phone' &&
					(this.$store.state.app.sidebars.left || this.$store.state.app.sidebars.right)) ||
				(this.$store.state.app.media === 'tablet' && this.$store.state.app.sidebars.right)
			);
		},
	},
	methods: {
		hideSidebars() {
			this.$store.commit('M_SET_APP_STATE', {sidebars: {left: false, right: false}});
		},
	},
	mounted() {
		const isSavedConfigurationUsed = !!this.$route.query.unitConfigurationId;
		if (!isSavedConfigurationUsed) {
			this.fireLogicOnInit();
		}
	},
};
</script>
